import "../../components/modal/ModalCss.scss";
import { Fragment, useEffect, useMemo, useState } from "react";
import BasicInput from "components/input/BasicInput";
import ReactDataTableModifiable from "components/DataTable/ReactDataTableModifiable";
import ReactModal from "react-modal";
import BasicButton from "components/button/BasicButton";
import { checkAndRemoveInvalid, checkRequiredAndInvalid, makeRequireColumns } from "js/requireCheck";

/**
 * 추가 상품 등록/수정 팝업
 */
function SupplementProductAddModModal (props) {

	const {isOpen, title, modalId, existsGroupName, onClose, initData, initMode, returnData} = props;

	const [supplementData, setSupplementData] = useState([]);
	const [supplementAddRow, setSupplementAddRow] = useState(null);
	const [supplementDelRow, setSupplementDelRow] = useState(null);
	const [selectRows, setSelectRows] = useState([]);
    const [dataSend, setDataSend] = useState([]);	// 테이블에서 데이터 변경 시 변경 데이터
	const [ data, setData ] = useState({});
	const [ mode, setMode ] = useState(initMode);
	
	//데이터 테이블 컬럼
	const columns = useMemo(() =>[
		{ header : "순서", col : "ordr", cellWidth: "100"},
		{ header : "추가상품명", col : "name", cellWidth: "100", type: "text", require: true, mod: true},
		{ header : "가격", col : "price", cellWidth: "100", type: "decimal", decimalPlaceCnt: 0, require: true, mod: true},
		{ header : "재고", col : "stockQuantity", cellWidth: "100", type: "decimal", decimalPlaceCnt: 0, require: true, mod: true},
		{ header : "사용여부", col: "usable", cellWidth : "100", type: "select", mod: true, require: true,
			option: [
				{label: "선택하세요", value: ""},
				{label: "사용", value: "Y"},
				{label: "미사용", value: "N"},
			],},
	], []);

	

	useEffect(() => {
		if(!isOpen) {
			setData({});
			setSupplementData([]);
			return;
		};
		if(mode === "mod") {
			const ordrData = initData.list.map((d, idx) => ({...d, ordr: idx+1, usable: d.usable ? "Y" : "N"}));
			
	
			setData(initData);
			// 여기서... 이제.... 순서랑 사용여부가 제대로 세팅이 안되네... 그거만 해보자...
			// 그리고 뭔가 수정 팝업 뜨거나 닫을때 오류가 많이 난다... 그거 잡자.
			setSupplementData(ordrData);
		}
		setSupplementAddRow(null);	// 이거 초기화 안해주면 닫았다가 다시 열면 행이 남아있음...

	}, [isOpen]);

	useEffect(() => {
		setMode(initMode);
	}, [initMode]);
	
	useEffect(() => {
		checkAndRemoveInvalid(data, "#supplementProductAddModModal");
	}, [data]);
	useEffect(() => {
		checkAndRemoveInvalid(dataSend, "#supplementProduct");
	}, [dataSend]);

	//행 추가 버튼
	const onAddRow=()=> {

		const newRow = {};
		const ordrArr = dataSend.map(d => d.ordr);
		const maxOrdr = ordrArr.length == 0 ? 1 : Math.max(...ordrArr) + 1;
		newRow.ordr = maxOrdr;
		setSupplementAddRow(newRow);
	}

	// 행 삭제 버튼
	const onDelRow = () => {
		setSupplementDelRow(selectRows.map(r => ({ordr: r.ordr})));
	}

	// 순서 변경
	const resetOrdr = (changedData) => {
		changedData.forEach((d, idx) => {
			d.ordr = idx + 1;
		});
		setSupplementData(changedData);
	}

	
	const handleDataChange = (e) => {
		const {name, value} = e.target;
		let d = {...data};
		d[name] = value;

		setData(d);
	}
	
	const onClickOk = () => {

		// 필수 체크 (표제외)
		const requiredColumns = ["groupName"];
		if(!checkRequiredAndInvalid(makeRequireColumns(requiredColumns), data, "#supplementProductAddModModal")) return;

		if(existsGroupName.includes(data.groupName)) {
			alert("이미 사용중인 그룹명 입니다.");
			return;
		}

		
		if(dataSend.length == 0) {
			alert("상품을 추가해 주세요.");
			return;
		}
		// 중복 체크 (표)
		if(!checkRequiredAndInvalid(columns, dataSend, "#supplementProduct")) return;
		
		// 그룹명 합치고, 순서는 제거하고. key도 원래거 긴거 붙이고..
		const saveData = dataSend.map(d => {
			const newD = {...d, ...data};
			delete newD.ordr;

			newD.usable = newD.usable === "Y" ? true : false;

			// const keys = Object.keys(tmpD);
			// const newD = {};
			// for(const key of keys) {
			// 	const newKey = col + "." + key;
			// 	newD[newKey] = tmpD[key];
			// }

			return newD;
		});
		

		returnData(saveData);
	}

	return (
		<ReactModal
			appElement={document.getElementById("root")}
			isOpen={isOpen}
			// onRequestClose={onClose}
			contentLabel={title + "팝업"}
			id={modalId}
		>
			<div className="me-modal abcdefg">
				<div className="me-modal-container" style={{width: "1000px", height: "600px"}}>
					<div className="me-modal-inner">
						<div className="me-modal-header handle-area">
							<h4 className="header-title">{title}</h4>
						</div>

						{/* <div className="me-modal-body" style={{overflowY: "scroll"}} >	달력때문에 overflow visible설정 */}
						<div className="me-modal-body" style={{overflowY: "hidden"}} >	{/* 달력때문에 overflow visible설정 */}
							<div className="body-area modal-form" id="supplementProductAddModModal">
								<h2>추가 상품</h2>
								<span>
									그룹: &nbsp; 
									<BasicInput item={{col: "groupName"}} value={data?.groupName} onChange={handleDataChange} width="500px" textAlign="left" />
								</span>
								<div className="table-buttons mg-t-10 mg-b-10">
									<BasicButton label="추가" className="btn-add" onClick={() => onAddRow()} />
									<BasicButton label="삭제" className="btn-del" disabled={selectRows.length === 0} onClick={() => onDelRow()} />
								</div>
								<div style={{height: "340px"}}>
								<ReactDataTableModifiable
									dataTableId="supplementProduct"
									columns={columns}
									customDatas={supplementData}
									addRow={supplementAddRow}
									delRow={supplementDelRow}
									delRowComplete={resetOrdr}
									hideCheckBox={false}
									returnSelectRows={(selects) => setSelectRows(selects)}
									dataSend={setDataSend}
									percentageWidth={true}
									maxHeight="340"
									rowDraggable={true}
									onRowDragDrop={resetOrdr}
								/>
								</div>
							</div>
						</div>
						
						<div className="me-modal-footer mg-t-10 mg-b-20">
							<div className="table-buttons" style={{justifyContent : "center"}}>
								<BasicButton label="취소" className="btn-cancel" onClick={onClose} style={{width: "100%"}} />
								<BasicButton label="확인" className="btn-save" onClick={onClickOk} style={{width: "100%"}} />

							</div>
						</div>
					</div>
				</div>
			</div>
		</ReactModal>
	);
}

export default SupplementProductAddModModal;
